import { MismoLoanPurpose } from './borrower'

export enum PropertyType {
  UNKNOWN = 'UNKNOWN',
  PRIMARY_RESIDENCE = 'PRIMARY_RESIDENCE',
  SECOND_HOME = 'SECOND_HOME',
  INVESTMENT = 'INVESTMENT_PROPERTY'
}

export enum GiftOrGrantSourceType {
  RELATIVE = 'RELATIVE',
  EMPLOYER = 'EMPLOYER',
  OTHER = 'OTHER'
}

export enum HousingExpenseTimingType {
  PROPOSED = 'Proposed'
}

export enum HousingExpenseType {
  FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST= 'FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST',
  HOMEOWNERS_INSURANCE= 'HOMEOWNERS_INSURANCE',
  REAL_ESTATE_TAX = 'REAL_ESTATE_TAX',
  MI_PREMIUM = 'MI_PREMIUM',
  OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST = 'OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST',
  HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES = 'HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES',
  OTHER = 'OTHER'
}

export interface PropertyAddress {
  street?: string;
  unit?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  countyName?: string;
}

export interface Mortgage {
  creditorName?: string;
  lienType?: string;
  monthlyPayment?: number;
  creditLimit?: number;
  loanAmount?: number;
  concurrentFinancingSourceType?: string, 
  concurrentFinancingSourceOtherDescription?: string 
  subordinateFinancingAmount?: number, 
  concurrentSubordinateFinancingAmount?: number, 
  subordinateFinancingInterestRate?: number, 
  subordinateFinancingTerm?: number, 
  subordinateFinancingMortgageBalance?: number, 
  subordinateFinancingMonthlyPayment?: number, 
  subordinateFinancingMonthlyPaymentLocked?: boolean,
  layeredTotalForgivableBalance?: number; 
}

export interface RentalIncome {
  rentalIncome?: number;
  netIncome?: number;
  monthlyRental?: number;
  occupancyRate?: string;
  occupancyRateLocked?: boolean;
  netMonthlyRental?: number;
  canHaveRentalIncome?: boolean;
  hasPrimaryResidentBorrower?: boolean;
  estimatedMonthlyMarketRent?: number;
  qualifyingMonthlyGrossRent?: number;
  isQualifyingMonthlyGrossRentLocked?: boolean;
  estimatedMonthlyPayment?: number;
  debtServiceCoverageRatio?: string;
  debtServiceCoverageRatioLocked?: boolean;
}

export interface GiftOrGrant {
  assetType?: string;
  marketValue?: number;
  source?: GiftOrGrantSourceType;
  isDeposited?: boolean;
}

export interface houseExpenses {
  expensePaymentAmount?: string;
  expenseTimingType?: HousingExpenseTimingType;
  expenseType?: HousingExpenseType;
}

export interface PropertyDetails {
  numberOfUnits?: number;
  propertyValue?: number;
  propertyType?: string;
  projectType?: string;
  isFHASecondaryResidence?: boolean;
  isMixedUseProperty?: boolean;
  isManufacturedHome?: boolean;
  monthlyRental?: number;
  occupancyRate?: string;
  occupancyRateLocked?: boolean;
  netMonthlyRental?: number;
  canHaveRentalIncome?: boolean;
  hasPrimaryResidentBorrower?: boolean;
  estimatedMonthlyMarketRent?: number;
  qualifyingMonthlyGrossRent?: number;
  isQualifyingMonthlyGrossRentLocked?: boolean;
  estimatedMonthlyPayment?: number;
  debtServiceCoverageRatio?: string;
  debtServiceCoverageRatioLocked?: boolean;
}

export interface LoanProperty {
  _id?: string;
  loanApplicationId?: string;
  borrowerId?: string;
  purpose?: MismoLoanPurpose;
  otherPurpose?: string;
  loanAmount?: number;
  purchasePrice?: number;
  isFirstMortgage?: boolean;
  propertyDetails?: PropertyDetails;
  propertyAddress?: PropertyAddress;
  propertyType?: PropertyType;
  otherMortgages?: Mortgage[];
  rentalIncomes?: RentalIncome[];
  giftOrGrants?: GiftOrGrant[];
  rentalIncome?: number;
  netIncome?: number;
  monthlyRental?: number;
  occupancyRate?: string;
  occupancyRateLocked?: boolean;
  netMonthlyRental?: number;
  canHaveRentalIncome?: boolean;
  hasPrimaryResidentBorrower?: boolean;
  estimatedMonthlyMarketRent?: number;
  qualifyingMonthlyGrossRent?: number;
  isQualifyingMonthlyGrossRentLocked?: boolean;
  estimatedMonthlyPayment?: number;
  debtServiceCoverageRatio?: string;
  debtServiceCoverageRatioLocked?: boolean;

  
  houseExpenses?: houseExpenses[];
  createdAt?: Date;
  updatedAt?: Date;
}